/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AssignIPv4 {
	NONE = "none",
	PREDEFINED = "predefined",
	ACCOUNT = "account",
}
